import { useEffect, useRef } from 'react';

/**
 * A custom hook that ensures an effect runs only once on mount.
 * Useful for initialization logic that should not re-run on subsequent renders.
 *
 */
export const useOnceEffect = (callback: () => void) => {
  const hasRunRef = useRef(false);
  const callbackRef = useRef(callback);

  // Update the callback ref on every render
  // eslint-disable-next-line react-hooks/refs
  callbackRef.current = callback;
  useEffect(() => {
    if (!hasRunRef.current && typeof callbackRef.current === 'function') {
      try {
        callbackRef.current();
      } catch (error) {
        // Let React handle the error boundary
        throw error;
      }
      hasRunRef.current = true;
    }
  }, []); // Empty deps array - truly runs only once
};